// 基准大小
const baseSize = 14;
// 最大字体大小
const maxFontSize = 22;
// 设置 rem 函数
export function setRem(screenWidth = 1440) {
    // 当前页面宽度相对于 1920 宽的缩放比例，可根据自己需要修改。
    const scale = window.innerWidth / screenWidth;
    // 设置页面根节点字体大小, 浏览器字体大小最小为12 ↓ 采用下面
    // let fontSize = baseSize * Math.min(scale, 2) > 12 ? baseSize * Math.min(scale, 2) : 12;
    // electron 可以更小 ↓ (个人项目需要)
    // 计算字体大小，但不超过最大限制
    const fontSize = Math.min(baseSize * Math.min(scale, 2), maxFontSize);
    document.documentElement.style.fontSize = fontSize + 'px';
}
// 初始化
setRem();
// 改变窗口大小时重新设置 rem,这里最好加上节流
window.onresize = function () {
    console.log('resize', window.innerWidth);
    setRem();
};
